// What the server says about how to sign in. Fetched at start rather than baked in at build
// time, so one built app runs in every environment.

import type { AgentModelDto, Features } from "../types/index.ts";
import { apiUrl } from "./http.ts";

export interface PublicConfig {
  tenantId: string;
  clientId: string;
  scope: string;
  /** What is switched on. A control for a feature that is off is not shown at all. */
  features: Features;
  /** The models a person may choose; the first is the default. One means nothing to choose. */
  models: AgentModelDto[];
}

export async function fetchConfig(): Promise<PublicConfig> {
  const response = await fetch(apiUrl("/v1/config"));
  if (!response.ok) throw new Error(`config: ${response.status}`);
  return (await response.json()) as PublicConfig;
}
